import './styles.css';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../components/Accessibility/DefaultText';
import { faTemperatureEmpty, faTemperatureFull, faTemperatureHalf } from '@fortawesome/pro-duotone-svg-icons';
import { sxCheckbox, sxInfoTextContainer } from './sxProps';

import { Box, Checkbox, FormControlLabel } from '@mui/material';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import { useNavigate } from 'react-router-dom';
import WhiteContainer from '../../../components/Accessibility/WhiteContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { aceiteNaoMostrarNovamente, getMostrarNovamenteNivelIniciar } from '../../../services/SaudeBemEstar/SaudeEmocionalService';
import { RetornaAceiteTermoResponse } from '../../../interfaces/entities/RetornaAceiteTermoResponse';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxCheckboxContrast } from '../../../assets/styles/CommonSxProps';
import { AutoAvaliacaoInfoPage } from './AutoAvaliacaoInfo';

const AutoAvaliacaoInfo2: React.FC<AutoAvaliacaoInfoPage> = ({onBack, onNext}) => {
  const accessibility = useAccessibility()
  const navigate = useNavigate();
  const [checked, setChecked] = useState<boolean>(false);
  const [acceptTerms, setAcceptTerms] = useState<RetornaAceiteTermoResponse | null>(null);

  useEffect(() => {
    getMostrarNovamenteNivelIniciar().then((response) => {
      setAcceptTerms(response)
    })
  }, [])

  const handleNext = async () => {
    if (acceptTerms !== null && checked) {
      await aceiteNaoMostrarNovamente(acceptTerms.idTermoResponsabilidade, acceptTerms.idOperador)
    }
    onNext()
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <div className='page-container'>
      <PageTitle text="Como realizar a avaliação de nível de estresse?" />

      <Box sx={sxInfoTextContainer}>
        <DefaultText text="Responda com sinceridade as questões a seguir para podermos compreender melhor a sua realidade." />
        <DefaultText text="O seu estado emocional vai gerar uma pontuação, na qual a intensidade do seu estresse, ansiedade e depressão será classificada em:" />
      </Box>

      <WhiteContainer className='info-estado-emocional-container' tabIndex={0}>
        <div className='info-estado-emocional-container-item'>
          <FontAwesomeIcon icon={faTemperatureEmpty} className='temperature-icon' color="#156D44" />
          <DefaultText text="<b>Baixo:</b> sua saúde emocional está em equilíbrio." />
        </div>
        <div className='info-estado-emocional-container-item'>
          <FontAwesomeIcon icon={faTemperatureHalf} className='temperature-icon' color="#F47920" />
          <DefaultText text="<b>Moderado:</b> sua saúde emocional necessita de cautela." />
        </div>
        <div className='info-estado-emocional-container-item'>
          <FontAwesomeIcon icon={faTemperatureFull} className='temperature-icon' color="#D84141" />
          <DefaultText text="<b>Elevado:</b> sua saúde emocional precisa de cuidados específicos. Atenção!" />
        </div>
      </WhiteContainer>

      <DefaultText text="E fique tranquilo(a)! Você pode refazer o teste a cada semana. Vamos começar?" />

      <DefaultButton onClick={handleNext} text="Iniciar avaliação" />

      <div className='flex-row'>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleCheck}
              style={accessibility.contrastColorAccessibility} />
          }
          label="Não exibir mais esta tela"
          sx={accessibility.contrastMode ? sxCheckboxContrast : sxCheckbox} />
      </div>

      <VoltarButton onClick={onBack} />

    </div>
  )
}

export default AutoAvaliacaoInfo2;